"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _react = require("react");

var _reactRedux = require("react-redux");

function useModelActions(model) {
  var dispatch = (0, _reactRedux.useDispatch)();
  return (0, _react.useMemo)(function () {
    var _context;

    return (0, _reduce.default)(_context = (0, _keys.default)((model === null || model === void 0 ? void 0 : model.actionCreators) || {})).call(_context, function (all, key) {
      all[key] = function () {
        var _model$actionCreators;

        return dispatch((_model$actionCreators = model.actionCreators)[key].apply(_model$actionCreators, arguments));
      };

      return all;
    }, {});
  }, [model, dispatch]);
}

var _default = useModelActions;
exports.default = _default;